module.exports = __webpack_public_path__ + "img/cazana-pattern.aa89c54c.png";